<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.privacyPolicyNav.overview')" link="privacyPolicies" />

    <template v-if="!isSystemRootInstance">
      <template v-for="type in enums['PrivacyPolicyType']">
        <item-nav-item :label="$t(`layout.nav.admin.privacyPolicyNav.${type}`)"
                       :params="{
                         type: type,
                         countryCode: hotelSettings.details.countryCode,
                       }"
                       link="privacyPolicy" />
      </template>
    </template>

    <template v-if="isSystemRootInstance && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
      <template v-for="country in hotelCountryCodes">
        <item-nav-group :label="`${$t('layout.nav.admin.privacyPolicyNav.systemPolicies')} (${country})`" :open="true">
          <template v-for="type in enums['PrivacyPolicyType']">
            <item-nav-group-item :label="`${$t(`layout.nav.admin.privacyPolicyNav.system.${type}`)} (${country}) 🔒`"
                                 :params="{ type: type, countryCode: country }"
                                 link="privacyPolicy" />
          </template>
        </item-nav-group>
      </template>
    </template>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy, sortBy, uniq } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';
import ItemNavItem from '../ItemNavItem.vue';

export default {
  name: 'PrivacyPolicyNav',
  components: { ItemNavItem, ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
    };
  },

  computed: {
    isSystemRootInstance: function () {
      return ['system', 'hotelmeister'].includes(this.hotelSettings.tenant.subdomain.toLowerCase());
    },
    hotelCountryCodes: function () {
      if (!this.hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')) return [];
      try {
        return uniq(this.$store.getters['hotel/hotels'].map(it => it.countryCode).filter(it => !isEmpty(it)));
      } catch (e) {
        console.error(e);
        return [];
      }
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  created: function () {
    if (this.isSystemRootInstance && isEmpty(this.$store.getters['hotel/hotels'])) {
      this.$store.dispatch('hotel/updateAccessibleHotels');
    }
  },

  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/PrivacyPolicyNav.vue